import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';
import { Shield, Lock } from 'lucide-react';
import { motion } from 'framer-motion';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAdmin();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login(password)) {
      navigate('/admin');
    } else {
      setError('Invalid admin password');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-400 to-indigo-500 py-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full mx-4"
      >
        <div className="bg-white rounded-2xl shadow-2xl border border-purple-100 overflow-hidden">
          <div className="bg-gradient-to-br from-purple-500 to-indigo-600 p-8">
            <div className="flex items-center gap-4 mb-4">
              <div className="bg-white p-3 rounded-xl shadow-lg">
                <Shield className="w-8 h-8 text-purple-600" />
              </div>
              <div>
                <h1 className="text-3xl font-extrabold text-white font-heading" data-testid="admin-login-title">
                  Admin Login
                </h1>
                <p className="text-white/90 font-medium">Access admin panel</p>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-8">
            <div className="mb-6">
              <label className="text-sm font-bold text-stone-600 mb-2 block">Admin Password</label>
              <div className="relative">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-purple-400" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError('');
                  }}
                  required
                  data-testid="admin-password-input"
                  placeholder="Enter admin password"
                  className="w-full h-12 pl-12 pr-4 rounded-xl border-2 border-purple-100 bg-white focus:border-purple-500 focus:ring-4 focus:ring-purple-100 transition-all outline-none"
                />
              </div>
              {error && (
                <p className="text-red-600 text-sm mt-2 font-medium" data-testid="error-message">{error}</p>
              )}
            </div>

            <button
              type="submit"
              data-testid="admin-login-button"
              className="w-full bg-gradient-to-r from-purple-500 to-indigo-600 text-white font-bold py-3 rounded-xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
            >
              Login as Admin
            </button>

            <p className="text-center text-sm text-gray-500 mt-4">
              Demo password: admin123
            </p>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin;